<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>档案管理</el-breadcrumb-item>
      <el-breadcrumb-item>国网配置下发规则</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：" v-if="user.username == 'admin'">
       <!-- <el-select size="small" v-model="departmentId" @change="changeDept" placeholder="请选择部门">
          <el-option v-for="item in departmentList" :key="item.id" :value="item.id" :label="item.departmentName"></el-option>
        </el-select> -->
        <el-input v-model="formInline.ruleConfigName" size="small" placeholder="请输入规则名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="handleEdit()">添加</el-button>
        <el-button size="small" type="primary"  @click="getData">搜索</el-button>
      </el-form-item>
    </el-form>  
    <!-- 数据列表 -->
    <el-table size="small" row-key="id" :data="dataList" v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;"
      :header-cell-style="this.$store.state.headerCss">
      <el-table-column type="index"></el-table-column>
      <el-table-column prop="ruleConfigName" label="规则名称">
      </el-table-column>
      <el-table-column prop="com" label="端口号" width="90">
      </el-table-column>
      <el-table-column prop="protocol" label="协议" width="90">
      </el-table-column>
      <el-table-column prop="password" label="密码">
      </el-table-column>
      <el-table-column prop="tarrif_num" label="费率个数" width="90">
      </el-table-column>
      <el-table-column prop="comaddr_clc" label="采集器通信地址">
      </el-table-column>
      <el-table-column prop="bitcount" label="电能示值及小数位" width="120">
      </el-table-column>
      <el-table-column prop="bigclass" label="用户大类" width="90">
      </el-table-column>
      <el-table-column prop="subclass" label="用户小类" width="90">
      </el-table-column>
      <el-table-column prop="intSum" label="整数位" width="90">
      </el-table-column>
      <el-table-column prop="decimalSum" label="小数位" width="90">
      </el-table-column>
      <el-table-column prop="bps" label="通信速率 " width="90">
      </el-table-column>
      <el-table-column label="操作" width="240" align="center">
        <template slot-scope="scope">

          <el-button size="mini" type="warning" @click="handelDetail(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteData(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增对话框 -->
    <el-dialog :title="title" :visible.sync="FromVisible" width="50%">
      <el-form :inline="true" label-width="150px" ref="editForm"  :model="editForm" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="规则名称" prop="ruleConfigName">
              <el-input placeholder="请输入规则名称" size="small" v-model="editForm.ruleConfigName"></el-input>
            </el-form-item>
            <el-form-item label="请选择通信速率" prop="bps">
              <el-select size="small" placeholder="" v-model="editForm.bps">
                <el-option v-for="item in bpsList" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="请选择端口号" prop="com">
              <el-select size="small" placeholder="" v-model="editForm.com">
                <el-option v-for="item in comList" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="请选择通信协议" prop="protocol">
              <el-select size="small" placeholder="" v-model="editForm.protocol">
                <el-option v-for="item in ptypes" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input  size="small" v-model="editForm.password"></el-input>
            </el-form-item>
            <el-form-item label="费率个数" prop="tarrif_num">
              <el-input  size="small" v-model="editForm.tarrif_num"></el-input>
            </el-form-item>
            <el-form-item label="采集通信地址" prop="comaddr_clc">
              <el-input  size="small" v-model="editForm.comaddr_clc"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">

            <el-form-item label="电能示值及小位数" prop="bitcount">
              <el-input  size="small" v-model="editForm.bitcount"></el-input>
            </el-form-item>
            <el-form-item label="用户大类" prop="bigclass">
              <el-input  size="small" v-model="editForm.bigclass"></el-input>
            </el-form-item>
            <el-form-item label="用户小类" prop="subclass">
              <el-input  size="small" v-model="editForm.subclass"></el-input>
            </el-form-item>
            <el-form-item label="有功电能示值的整数位个数" prop="intSum">
              <el-input  size="small" v-model="editForm.intSum"></el-input>
            </el-form-item>
            <el-form-item label="有功电能示值的小数位个数" prop="decimalSum">
              <el-input  size="small" v-model="editForm.decimalSum"></el-input>
            </el-form-item>

          </el-col>
        </el-row>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="FromVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" :loading="saveLoad" @click="saveFx">确 定</el-button>
      </div>
    </el-dialog>





  </div>
</template>

<script>
  import {
    getDepartmentTerminalInfoLis,
    getEnergyTypeList,
    getTerminalInfoByDepId,
    getMeterInfoList,

    addGWRuleConfig,
    findAllGWRuleConfig,
    deleteGWRuleConfig,
    updateGWRuleConfig

  } from '../../api/energyMG'
  import {
    getNyfx,
    addFx,
    getGs,
    addFormula,
    delFormula,
    getMeterList,
    saveEnergyDataItem
  } from '../../api/analysisMG'

  export default {
    data() {
      return {
        departmentList:[],
        formInline:{
          ruleConfigName:"",
          currentPage:'1',
          pageSize:'10',
          total:'',
        },
        departmentId:"",
        loading:false,
        dataList:[],
        FromVisible:false,
        title:'添加',
        saveLoad:false,
        addFormVisible:false,
        editForm:{
            "ruleConfigName": "",
            "com": 3,
            "protocol": 32,
            "password": "000000000000",
            "tarrif_num": 4,
            "comaddr_clc": "000000000000",
            "bitcount": 15,
            "bigclass": 0,
            "subclass": 0,
            "intSum": 5,
            "decimalSum": 2,
            "bps": 3
        },
         bpsList:[
            { label: 'bps_600', value:1 },
            { label: 'bps_1200', value:2 },
            { label: 'bps_2400', value:3 },
            { label: 'bps_4800', value:4 },
            { label: 'bps_7200', value:5 },
            { label: 'bps_9600', value:6 },
            { label: 'bps_19200', value:7 },
         ],

         comList:[
           { label:'com_485_1', value:2},
           { label:'com_485_2', value:3},
           { label:'com_485_3', value:4},
           { label:'com_485_4', value:5},
           { label:'com_485_5', value:6},
           { label:'com_485_6', value:7},
           { label:'com_485_7', value:8},
           { label:'com_485_8', value:9},
           { label:'com_485_9' ,value :10},
           { label:'com_485_10',value :11},
           { label:'com_485_11',value :12},
           { label:'com_485_12',value :13},
           { label:'com_485_13',value :14},
           { label:'com_485_14',value :15},
           { label:'com_485_15',value :16},
           { label:'com_485_16',value :17},
           { label:'com_485_17',value :18},
           { label:'com_485_18',value :19},
           { label:'com_485_19',value :20},
           { label:'com_485_20',value :21},
           { label:'com_485_21',value :22},
           { label:'com_485_22',value :23},
           { label:'com_485_23',value :24},
           { label:'com_485_24',value :25},
           { label:'com_485_25',value :26},
           { label:'com_485_26',value :27},
           { label:'com_485_27',value :28},
           { label:'com_485_28',value :29},
           { label:'com_485_29',value :30},
           { label:'com_485_30',value :31},
         ],


         ptypes:[
           { label:'DLT645_1997', value:1},
           { label:'DLT645_AcSamplingUnit', value:2},
           { label:'DLT645_2007', value:30},
           { label:'DLT645_WaterPowerNaturalGas', value:32},
         ],
         rules:{
           ruleConfigName: [{
             required: true,
             message: '规则名称不能为空',
             trigger: 'blur'
           }],
           bps: [{
             required: true,
             message: '请选择通信速率',
             trigger: 'change'
           }],
           com: [{
             required: true,
             message: '请选择端口号',
             trigger: 'change'
           }],
           protocol: [{
             required: true,
             message: '请选择通信协议',
             trigger: 'change'
           }],
           password: [{
             required: true,
             message: '密码不能为空',
             trigger: 'blur'
           }],
           tarrif_num: [{
             required: true,
             message: '费率个数不能为空',
             trigger: 'blur'
           }],
           comaddr_clc: [{
             required: true,
             message: '采集通信地址不能为空',
             trigger: 'blur'
           }],
           bitcount: [{
             required: true,
             message: '电能示值及小位数不能为空',
             trigger: 'blur'
           }],
           bigclass: [{
             required: true,
             message: '用户大类不能为空',
             trigger: 'blur'
           }],
           subclass: [{
             required: true,
             message: '用户小类不能为空',
             trigger: 'blur'
           }],
           intSum: [{
             required: true,
             message: '有功电能示值的整数位个数不能为空',
             trigger: 'blur'
           }],
            decimalSum: [{
             required: true,
             message: '有功电能示值的小数位个数不能为空',
             trigger: 'blur'
           }],
         }

      }
    },
    computed: {
      tables() {
        let search = this.searchDatas
        if (search) {
          return this.MeterInfoList.filter(data => {
            return Object.keys(data).some(key => {
              return String(data[key]).toLowerCase().indexOf(search) > -1
            })
          })
        }
        return this.MeterInfoList
      }
    },
    created() {
      this.getJzData()

      this.$store.dispatch('getEnergyTypeConfig').then((res) => {
        this.energyData = res
      })
      this.user = JSON.parse(sessionStorage.getItem('userdata'))



    },

    methods: {


      closeAdd() {
        this.meterForm.meterName = ""
        this.meterForm.terminalCode = ""
      },
      handleyt() {
        this.showYongTu = true
        this.yongTuForm.energyName = ''
      },

      getAddMeterIds(e) {
        this.tempAddMeterList = e
      },
      deleteData(row) {
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(res => {

          deleteGWRuleConfig({
            id: row.id
          }).then(res => {
            if (res.status == 1) {

              this.getData()
              this.$message.success("操作成功")
            } else {
              this.$message.error(res.msg)
            }

          })
        })

      },





      //获取集中器信息
      getJzData: function() {
        return new Promise((resolve, reject) => {
          getDepartmentTerminalInfoLis().then(res => {
            this.treeLoad = false
            if (res.status == 1) {
              this.departmentList = res.data.menuDepList
              this.departmentId = this.departmentList[0].id
              this.getData()
            } else {
              this.$message.error(res.msg)
            }
          })
        })

      },
      changeData(data) {
        data.forEach(item => {
          if (item.terminalInfo) {
            if (!item.deps) {
              item.deps = []
            }
            item.terminalInfo.forEach(sitem => {
              let obj = {}
              obj.id = sitem.id
              obj.departmentName = sitem.terminalName
              obj.terminalCode = sitem.terminalCode
              obj.isJz = true
              item.deps.push(obj)
            })
          }
          if (item.deps) {
            this.changeData(item.deps)
          }
        })

        return data
      },

      handleNodeClick(data) {
        this.getJZ = data.departmentName
        this.energyFrom.terminalCode = data.terminalCode
        this.visible = false
      },




      changeDept() {
        if (this.user.username != 'admin') {
          this.departmentId = this.user.departmentId
        }
        let param = {
          departmentId: this.departmentId
        }

        this.getData()


      },
      getData() {
        this.loading = true
        findAllGWRuleConfig(this.formInline).then(res => {
          this.loading = false
          if (res.status == 1) {
            this.dataList = res.data.content
          }
        })
      },


      handleEdit() {
        this.FromVisible = true
        this.title = '添加'
        this.editForm = this.$options.data().editForm
      },

      handelDetail(row) {
        this.title = '修改'
        this.FromVisible = true
        this.editForm.id = row.id
        this.editForm.ruleConfigName = row.ruleConfigName
        this.editForm.com = row.com
        this.editForm.protocol = row.protocol
        this.editForm.password = row.password
        this.editForm.tarrif_num = row.tarrif_num
        this.editForm.comaddr_clc = row.comaddr_clc
        this.editForm.bitcount = row.bitcount
        this.editForm.bigclass = row.bigclass
        this.editForm.subclass = row.subclass
        this.editForm.intSum = row.intSum
        this.editForm.decimalSum = row.decimalSum
        this.editForm.bps = row.bps
      },


      //保存
      saveFx() {

        this.$refs['editForm'].validate((valid) => {
          if (valid) {
           this.saveLoad = true
           if(this.title == '添加'){
             this.add()
           }else{
             this.upDate()
           }
          } else {
            return false;
          }
        });
      },

      add(){
        addGWRuleConfig(this.editForm).then(res => {
          this.saveLoad = false
          if (res.status == 1) {
            this.$message.success('操作成功！')
            this.getData()
            this.FromVisible = false
          } else {
            this.$message.error(res.msg)
          }
        })
      },

      upDate(){
        addGWRuleConfig(this.editForm).then(res => {
          this.saveLoad = false
          if (res.status == 1) {
            this.$message.success('操作成功！')
            this.getData()
            this.FromVisible = false
          } else {
            this.$message.error(res.msg)
          }
        })
      },

      getBindMeters() {
        this.loadE = true
        getMeterInfoList(this.meterForm).then(res => {
          this.loadE = false
          this.loadMeter = false
          if (res.status == 1) {
            if (this.meterForm.areaId != '') {
              this.choisData = res.data.data
            }

            this.MeterInfoList = res.data.data
          }
        })
      },
      deleteGs(row) {
        let param = {
          areaId: row.id
        }
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          AreaDelete(param).then(res => {
            if (res.status == 1) {
              this.$message.success('操作成功！')
              this.getData()
            }
          })
        })

      }
    }
  }
</script>

<style scoped>
  .treel {
    padding: 0 20px;
    font-size: 13px;
  }

  .gs {
    height: 100px;
  }

  .treel i {
    font-size: 14px;
  }

  .treel /deep/ .el-tree-node {
    white-space: normal !important;
  }

  .treel /deep/ .el-tree-node__content {
    height: auto;
    padding: 6px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/archives/setgw.vue